import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR } from '../../../../../config/tables'

function TablaCumplimientoDeCuposExportador () {
  return <MuiTable id={TABLA_CUMPLIMIENTO_DE_CUPOS_EXPORTADOR} />
}

export default TablaCumplimientoDeCuposExportador
